// @ts-ignore
import Vue from 'vue';

// @ts-ignore
import { Component } from "vue-property-decorator";

//Components
import WithRender from "Components/AmbassadorProjects/ambassador-projects.html";

//Child Components
import WorkbenchCard from "Components/Shared/WorkbenchCard/WorkbenchCard";
import { IfcWorkbenchPageData } from 'Interfaces/ifcWorkbenchPageData';

@WithRender
@Component({
	components: {
		WorkbenchCard
	}
})

export default class AmbassadorProjects extends Vue {
	projects:any = document.querySelector('.js-projects') ? JSON.parse(document.querySelector('.js-projects').getAttribute('data-projects')) : null;
    pageData = JSON.parse(document.querySelector('.js-page-data').getAttribute('data-page-data')) as IfcWorkbenchPageData;
	translations:any = document.querySelector('.js-page-data') ? JSON.parse(document.querySelector('.js-page-data').getAttribute('data-translations')) : null;    

	created() {		
	}
}
